import { collection, getDocs, addDoc, doc, writeBatch, query, where } from "firebase/firestore";
import { firebase, firebase_auth } from "../firebase-config";
import { BaseUrl, COLLECTIONS, DOMAINURL, EMP_DOMAIN } from "../config";
import axiosInstance from "../axios";
import dayjs from "dayjs";
import moment from "moment";
import { getLoginToken } from "../storage";

const collectionNotifications = collection(firebase, COLLECTIONS.NOTIFICATIONS);
const collectionIssueNotifications = collection(firebase, COLLECTIONS.ISSUE_NOTIFICATIONS);

/**
 * Get Tasks list from standardtasks collection (shown while create client)
 * @param {*} onSuccess
 * @param {*} onError
 */
export async function getNotificationList(onSuccess, onError) {
  try {
    const querySnapshot = await getDocs(collectionNotifications);
    let results = [];
    querySnapshot.forEach((doc) => {
      let data = doc.data();
      results.push({ id: doc.id, ...data });
    });

    onSuccess && onSuccess(results);
  } catch (error) {
    console.log("Error getting documents: ", error);
    onError && onError(error);
  }
}

function formatMessageForEmail(message) {
  if (!message) return "";
  const hasHTML = /<\/?[a-z][\s\S]*>/i.test(message);

  let safeMessage;
  if (hasHTML) {
    safeMessage = message.replace(/\n/g, "<br/>");
  } else {
    safeMessage = message
      ?.replace(/&/g, "&amp;")
      ?.replace(/</g, "&lt;")
      ?.replace(/>/g, "&gt;");
  }
  return `<pre style="white-space: pre-wrap; font-family: inherit; font-size: 16px; color: #333; margin: 0;">${safeMessage}</pre>`;
}

function formatMessageForText(message) {
  if (!message) return "";

  let formatted = message?.replace(/<br\s*\/?>/gi, "\n");
  formatted = formatted?.replace(/<\/(p|div|li|h[1-6])>/gi, "\n");
  formatted = formatted?.replace(/<\/?[^>]+(>|$)/g, "");
  formatted = formatted?.replace(/\n\s*\n\s*/g, "\n\n");
  return formatted?.trim();
}
/**
 * send notification and save it to database
 * @param {*} formData : data to be saved and sent as notification
 * @param {*} onSuccess
 * @param {*} onError
 */
export async function saveNotification(formData, companyName, onSuccess, onError) {
  const currentUserId = firebase_auth.currentUser.uid;

  try {
    const docRef = await addDoc(collectionNotifications, {
      ...formData,
      createdBy: currentUserId,
      createdOn: new Date().getTime(),
    });

    const docdata = { ...formData, id: docRef.id };

    if (formData?.schedule === true) {
      onSuccess?.({ status: true, data: docdata });
      return;
    }

    const emailList = formData?.Employee?.map((item) => item?.email);
    const phoneList = formData?.Employee?.map((item) => item?.phone);
    const userIds = formData?.Employee?.map((item) => item?.id);
    const authHeaders = {
      "Content-Type": "application/json",
      withCredentials: true,
      Authorization: `Bearer ${getLoginToken()}`,
    };
    const message = formData?.Message;
    const type = formData?.Type;

    const promises = [];

    const isType = (t) => Array.isArray(type) ? type.includes(t) : type === t;

    if (isType("PushNotification")) {
      promises.push(
        axiosInstance.post(
          `${BaseUrl}sendPushNotifications`,
          {
            userIds,
            title: "ProTeams - Notification",
            textMessage: `${formatMessageForText(message)}`,
            extData: { type: "Messages", id: docdata?.id },
          },
          { headers: authHeaders }
        )
      );
    }

    if (isType("Email")) {
      promises.push(
        axiosInstance.post(
          `${BaseUrl}sendEmailData`,
          {
            email: emailList,
            subject: `Proteams - Notification (${companyName})`,
            contenttxt: `
              <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #eee; border-radius: 10px; line-height: 1.6;">
                
                <div style="text-align: center; margin-bottom: 20px;">
                  <img src="https://${DOMAINURL}/csmGrayTextLogin.png" alt="ProTeams Logo" style="height: 60px;" />
                </div>

                <h2 style="font-size: 20px; margin-bottom: 15px; color: #222; text-align: left;">ProTeams Message</h2>

                <div style="font-size: 16px; color: #333; margin-bottom: 20px; text-align: left;">
                  ${formatMessageForEmail(message)}
                </div>

                <p style="font-size: 14px; color: #666; margin-top: 10px; text-align: left;">
                  If you have any questions about using the CMS or need assistance getting started, 
                  please don't hesitate to reach out to our 
                  <a href="https://${EMP_DOMAIN}/support" style="color: #2980ba; text-decoration: underline;">support team</a>.
                </p>

                <hr style="margin: 30px 0 0; border: none; border-top: 1px solid #eee;" />

                <div style="text-align: center; color: #666; font-size: 13px;">
                  <p>&copy; ${new Date().getFullYear()} ProTeams All rights reserved.</p>
                </div>
              </div>
            `
          },
          { headers: authHeaders }
        )
      );
    }

    if (isType("Push")) {
      promises.push(
        axiosInstance.post(
          `${BaseUrl}sendSmsText`,
          {
            phoneNumber: phoneList,
            textMessage: `ProTeams Message\n\n${formatMessageForText(message)}`,
          },
          { headers: authHeaders }
        )
      );
    }

    if (isType("Both")) {
      const pushText =
        message.length > 150 ? `${message.substring(0, 140)}...` : message;

      promises.push(
        axiosInstance.post(
          `${BaseUrl}sendEmailData`,
          {
            email: emailList,
            subject: `Proteams - Notification (${companyName})`,
           contenttxt: `
              <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #eee; border-radius: 10px; line-height: 1.6;">
                
                <div style="text-align: center; margin-bottom: 20px;">
                  <img src="https://${DOMAINURL}/csmGrayTextLogin.png" alt="ProTeams Logo" style="height: 60px;" />
                </div>

                <h2 style="font-size: 20px; margin-bottom: 15px; color: #222; text-align: left;">ProTeams Message</h2>

                <div style="font-size: 16px; color: #333; margin-bottom: 20px; text-align: left;">
                  ${formatMessageForEmail(message)}
                </div>

                <p style="font-size: 14px; color: #666; margin-top: 10px; text-align: left;">
                  If you have any questions about using the CMS or need assistance getting started, 
                  please don't hesitate to reach out to our
                  <a href="https://${EMP_DOMAIN}/support" style="color: #2980ba; text-decoration: underline;">support team</a>.
                </p>

                <hr style="margin: 30px 0 0; border: none; border-top: 1px solid #eee;" />

                <div style="text-align: center; color: #666; font-size: 13px;">
                  <p>&copy; ${new Date().getFullYear()} ProTeams All rights reserved.</p>
                </div>
              </div>
            `
          },
          { headers: authHeaders }
        )
      );

      promises.push(
        axiosInstance.post(
          `${BaseUrl}sendSmsText`,
          {
            phoneNumber: phoneList,
            textMessage: `ProTeams Message\n\n${formatMessageForText(message)}`,
          },
          { headers: authHeaders }
        )
      );

      promises.push(
        axiosInstance.post(
          `${BaseUrl}sendPushNotifications`,
          {
            userIds,
            title: "ProTeams - Notification",
            textMessage: `${formatMessageForText(pushText)}`,
            extData: { type: "Messages", id: docdata?.id },
          },
          { headers: authHeaders }
        )
      );
    }

    await Promise.all(promises);

    onSuccess?.({ status: true, data: docdata });
  } catch (error) {
    console.log(`ERROR: ${collectionNotifications.id} ${error}`);
    onError?.({ status: false, error });
  }
}

function formatEmailMessage(message) {
  const lines = message?.split(/<br\s*\/?>|\n/)?.map(line => line.trim())?.filter(Boolean);

  let formatted = '';
  let inList = false;

  lines?.forEach(line => {
    if (/^\d+\.\s+/.test(line)) {
      if (!inList) {
        formatted += '<ol>';
        inList = true;
      }
      formatted += `<li>${line.replace(/^\d+\.\s+/, '')}</li>`;
    } else {
      if (inList) {
        formatted += '</ol>';
        inList = false;
      }
      formatted += `<p>${line}</p>`;
    }
  });

  if (inList) formatted += '</ol>';

  return formatted;
}

export async function saveNotification2(notifications, supply, orderId, clientName, companyName, onSuccess, onError) {
  let currentUserId = firebase_auth.currentUser.uid;
  const batch = writeBatch(firebase);
  const results = [];
  const pushNotificationPromises = [];
  const emailPromises = [];

  const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      withCredentials: true,
      ...authHeaders,
    },
  };

  try {
    for (const formData of notifications) {
      const docRef = doc(collectionIssueNotifications);
      batch.set(docRef, {
        ...formData,
        createdBy: currentUserId,
        createdOn: new Date().getTime(),
      });

      const docdata = { ...formData, id: docRef.id };
      results.push(docdata);

      let emailList = formData.Employee.map((item) => item.email);
      let userIds = formData.Employee.map((item) => item.id);
      const extData = formData.extData || { type: "Messages", id: docdata?.id };
      const formattedMessage = formatEmailMessage(formData?.Message);

      if (formData.Type === "PushNotification") {
        const frmPush = {
          userIds,
          title: "ProTeams - Alert",
          textMessage: formData.Message,
          extData,
        };
        pushNotificationPromises.push(
          axiosInstance.post(`${BaseUrl}sendPushNotifications`, frmPush, axiosConfig)
        );
      }

      if (formData.Type === "Email") {
        const emailData = {
          email: emailList,
          subject: supply && orderId && clientName ? `ProTeams - Supply Request: ${orderId} (${clientName} of ${companyName})` : `Proteams`,
          contenttxt: `
              <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #eee; border-radius: 10px; line-height: 1.6;">
                
                <div style="text-align: center; margin-bottom: 20px;">
                  <img src="https://${DOMAINURL}/csmGrayTextLogin.png" alt="ProTeams Logo" style="height: 60px;" />
                </div>

                <h2 style="font-size: 20px; margin-bottom: 15px; color: #222; text-align: left;">ProTeams Message</h2>

                <div style="font-size: 16px; color: #333; margin-bottom: 20px; text-align: left;">
                  ${formattedMessage}
                </div>

                <p style="font-size: 14px; color: #666; margin-top: 10px; text-align: left;">
                  If you have any questions about using the CMS or need assistance getting started, 
                  please don't hesitate to reach out to our support team.
                </p>

                <hr style="margin: 30px 0 0; border: none; border-top: 1px solid #eee;" />

                <div style="text-align: center; color: #666; font-size: 13px;">
                  <p>&copy; ${new Date().getFullYear()} ProTeams All rights reserved.</p>
                </div>
              </div>`,
          supplies: supply ? true : false,
        };
        emailPromises.push(
          axiosInstance.post(`${BaseUrl}sendEmailData`, emailData, axiosConfig)
        );
      }
    }

    await Promise.all([...pushNotificationPromises, ...emailPromises]);

    await batch.commit();

    onSuccess && onSuccess({ status: true, data: results });
  } catch (error) {
    console.error(`ERROR: ${collectionIssueNotifications.id} ${error.message}`);
    onError && onError({ status: false, error: error.message });
  }
}

export async function clothingSaveNotification(notifications, supply, orderId, clientName, onSuccess, onError) {
  let currentUserId = firebase_auth.currentUser.uid;
  const batch = writeBatch(firebase);
  const results = [];
  const pushNotificationPromises = [];
  const emailPromises = [];

  const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      withCredentials: true,
      ...authHeaders,
    },
  };

  try {
    for (const formData of notifications) {
      const docRef = doc(collectionIssueNotifications);
      batch.set(docRef, {
        ...formData,
        createdBy: currentUserId,
        createdOn: new Date().getTime(),
      });

      const docdata = { ...formData, id: docRef.id };
      results.push(docdata);

      const emailList = formData.Employee.map(item => item.email);
      const userIds = formData.Employee.map(item => item.id);

      const extData = formData.extData || { type: "Messages", id: docdata?.id };

      if (formData.Type === "PushNotification") {
        const frmPush = {
          userIds,
          title: "ProTeams - Alert",
          textMessage: formData.Message,
          extData,
        };
        pushNotificationPromises.push(
          axiosInstance.post(`${BaseUrl}sendPushNotifications`, frmPush, axiosConfig)
        );
      }

      if (formData.Type === "Email") {
        const emailData = {
          email: emailList,
          subject: supply && orderId && clientName ? `(${clientName}) Supplies - #${orderId}` : `Proteams`,
           contenttxt: `
              <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #eee; border-radius: 10px;">
                
                <div style="text-align: center; margin-bottom: 20px;">
                  <img src="https://${DOMAINURL}/csmGrayTextLogin.png" alt="ProTeams Logo" style="height: 60px;" />
                </div>
                
                <p style="font-size: 18px; margin: 0 0 15px 0;">Hello,</p>

                <p style="font-size: 16px; line-height: 1.5; margin: 0 0 15px 0;">
                  Your request for your company shirts has been completed and your item(s) have been delivered. 
                  If there are any issues with these items, please contact your support team.
                </p>

                <p style="font-size: 16px; margin: 0 0 20px 0;">Thank you,</p>

                <p style="font-size: 14px; color: #666; margin: 0 0 20px 0;">
                  If you have any questions about using the CMS or need assistance getting started, 
                  please don't hesitate to reach out to our support team.
                </p>

                <hr style="margin: 30px 0 0; border: none; border-top: 1px solid #eee;">

                <div style="text-align: center; color: #666; font-size: 13px; margin-top: 15px;">
                  <p style="margin: 0;">&copy; ${new Date().getFullYear()} ProTeams All rights reserved.</p>
                </div>
              </div>`,
          supplies: supply ? true : false,
        };
        emailPromises.push(
          axiosInstance.post(`${BaseUrl}sendEmailData`, emailData, axiosConfig)
        );
      }
    }

    await Promise.all([...pushNotificationPromises, ...emailPromises]);

    await batch.commit();

    onSuccess && onSuccess({ status: true, data: results });
  } catch (error) {
    console.error(`ERROR: ${collectionIssueNotifications.id} ${error.message}`);
    onError && onError({ status: false, error: error.message });
  }
}

export async function fetchCompanyNotifications(companyId) {
  try {
    const subsRef = collection(firebase, COLLECTIONS.NOTIFICATIONS);

    const q = companyId
      ? query(subsRef, where("companyId", "==", companyId))
      : query(subsRef);

    const querySnapshot = await getDocs(q);

    const notification = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return { status: "success", data: notification };
  } catch (error) {
    console.error("Error finding notification:", error);
    return { status: "error", message: error.message };
  }
}

export const filterAndGroupNotifications = (notifications, rangeDays = 7) => {
  const now = moment();
  const startDate = moment().subtract(rangeDays, 'days');

  const typeMap = {
    SMS: [],
    PushNotification: [],
    Email: []
  };

  notifications?.forEach(notification => {
    const createdDate = moment(notification?.createdOn);

    if (createdDate.isBetween(startDate, now, null, "[]")) {
      const types = Array.isArray(notification?.Type)
        ? notification?.Type
        : [notification?.Type];

      const normalizedTypes = new Set();

      types.forEach(type => {
        if (type === "Both") {
          normalizedTypes.add("SMS");
          normalizedTypes.add("PushNotification");
          normalizedTypes.add("Email");
        } else if (type === "Push") {
          normalizedTypes.add("SMS");
        } else if (type === "PushNotification") {
          normalizedTypes.add("PushNotification");
        } else if (type === "Email") {
          normalizedTypes.add("Email");
        }
      });

      normalizedTypes.forEach(type => {
        if (typeMap[type]) {
          typeMap[type].push(notification);
        }
      });
    }
  });

  return typeMap;
};

export async function getUnreadNotificationsByCompany(onSuccess, onError) {
  try {
    const colRef = collection(firebase, COLLECTIONS.NOTIFICATIONS);
    const startDate = moment().subtract(90, "days").startOf("day").toDate();
    const endDate = moment().endOf("day").toDate();

    const q = query(
      colRef,
      where("read", "==", false),
      where("createdOn", ">=", startDate),
      where("createdOn", "<=", endDate)
    );

    const querySnapshot = await getDocs(q);

    const notifications = [];
    querySnapshot.forEach((doc) => {
      notifications.push({ id: doc.id, ...doc.data() });
    });

    onSuccess && onSuccess({ status: true, data: notifications });
  } catch (error) {
    onError && onError({ status: false, error });
  }
}

export async function getMessageByDateandCompany(formData, companyId, onSuccess, onError) {
  const collectionRef = collection(firebase, COLLECTIONS.NOTIFICATIONS);
  try {
    const startTimestamp = dayjs(formData.startDate).valueOf();
    const endTimestamp = dayjs(formData.endDate).valueOf(); 

    const filteredQuery = query(
      collectionRef,
      where("companyId", "==", companyId),
      where("createdOn", ">=", startTimestamp),
      where("createdOn", "<=", endTimestamp)
    );

    const querySnapshot = await getDocs(filteredQuery);
    let results = [];
    querySnapshot.forEach((doc) => {
      let data = doc.data();
      results.push({ id: doc.id, ...data });
    });
    
    onSuccess && onSuccess(results);
    return results;
  } catch (error) {
    console.log("Error getting documents: ", error);
    onError && onError(error);
  }
}